import { render } from "./CadastroLicencaDialog.vue?vue&type=template&id=1add6135&scoped=true"
import script from "./CadastroLicencaDialog.vue?vue&type=script&lang=js"
export * from "./CadastroLicencaDialog.vue?vue&type=script&lang=js"

import "./CadastroLicencaDialog.vue?vue&type=style&index=0&id=1add6135&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1add6135"]])

export default __exports__